// extracted by mini-css-extract-plugin
module.exports = {"disabled":"Btn_disabled__bz1vU","btn":"Btn_btn__2hQO8"};